import React from 'react'

import {type InfoBlock as InfoBlockType, BlockTypes} from '../../../../api'
import {BlockWithCommonSubblocks} from './components/BlockWithCommonSubblocks'
import {BlockWithoutValues} from './components/BlockWithoutValues'
import {BlockWithRequirements} from './components/BlockWithRequirements'
import {CommonBlock} from './components/CommonBlock'

type Props = {
  block: InfoBlockType
  isTopBlock?: boolean
}

export function InfoBlock({block, isTopBlock}: Props) {
  switch (block.type) {
    case BlockTypes.BLOCK_WITHOUT_VALUES:
      return <BlockWithoutValues block={block} isTopBlock={isTopBlock} />

    case BlockTypes.BLOCK_WITH_REQUIREMENTS:
      return <BlockWithRequirements block={block} />

    case BlockTypes.COMMON_BLOCK:
      return <CommonBlock block={block} />

    case BlockTypes.BLOCK_WITH_COMMON_SUBBLOCKS:
      return <BlockWithCommonSubblocks block={block} />

    default:
      return null
  }
}
